import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const eocOverviewAllTeamsRoute: InvariantJiraRoute = {
	name: 'eoc-overview-all-teams',
	path: '/jira/ops/overview/teams',
	exact: true,
};
